import { CSSProperties } from 'react';
import ELEMENT from 'common/element';

import './LoadingPlaceholder.scss';

type LoadingPlaceholderProps = {
  description?:         string;
  offsetTop?:           number;
  height?:              number;
  spinnerHeight?:       number;
};

/**
 * Renders a loading spinner (and optional text if specified).
 *
 * @param props.description Optional text, e.g.: 'Loading' -- add only if really necessary
 */
function LoadingPlaceholder({
  description,
  offsetTop = 150,
  height,
  spinnerHeight = 50,
}: LoadingPlaceholderProps): JSX.Element {

  const containerStyle: CSSProperties = { marginTop: offsetTop + 'px' };
  const spinnerStyle = {
    height: spinnerHeight + 'px',
    width:  spinnerHeight + 'px',
  };
  if (height) {
    containerStyle.height = height + 'px';
  }

  return (
    <div className="LoadingPlaceholder__Container" style={containerStyle}>
      <div className="LoadingPlaceholder__Spinner" style={spinnerStyle} data-test-id={ELEMENT.commonLoadingPlaceholder} />
      {description && <div className="LoadingPlaceholder__Description">{description}</div>}
    </div>
  );
}

export default LoadingPlaceholder;
